module.exports = __webpack_public_path__ + "img/warn_bg2.21bd93ad.png";